import { createLoadableComponent, createModuleLoader } from '@mews/framework';
import { TextKey } from '@mews-distributor/common';

import { showSpaceCategories } from '../../actions/navigation';
import { createViewLoadingError } from '../../components/common/createViewLoadingError';

import { moduleId } from './constants';

const loader = createModuleLoader({
    name: moduleId,
    load: async () => import(/* webpackChunkName: "rates" */ './module'),
    dependencies: [],
});

export const Rates = createLoadableComponent({
    loader,
    component: 'RatesView',
    ...createViewLoadingError({
        loadingStatusTextKey: TextKey.LoadingAvailability,
        dismissAction: showSpaceCategories,
    }),
});
